import {
  useHeaderStore,
  useUserContext,
} from '@issuemanager/apps/client/contexts';
import { useAdmin } from '@issuemanager/apps/client/hooks';
import { paths } from '@issuemanager/apps/client/paths';
import { Stack } from '@mui/system';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { HeaderTabs } from '../../components/header-tabs';

export default function () {
  const { t } = useTranslation(['common', 'settings']);
  const { setHeaderProps } = useHeaderStore();
  const isAdmin = useAdmin();
  const { userRoles } = useUserContext();

  const settingsTabs = [
    {
      path: `/${paths.settings.index}/${paths.issueTypes.index}`,
      label: t('settings:issueTypes.tabName'),
      disabled: !isAdmin,
    },
  ];

  const tabs = useMemo(
    () => [
      ...(isAdmin ? settingsTabs : []),
      {
        path: `/${paths.settings.index}/${paths.issueTemplates.index}`,
        label: t('settings:issueTemplates.tabName'),
        disabled: !userRoles?.hasManagedIssueTypes,
        tooltip: t('errors.settingsTabDisabled'),
      },
      {
        path: `/${paths.settings.index}/${paths.slaConfiguration.index}`,
        label: t('settings:slaConfiguration.tabName'),
        disabled: !userRoles?.hasManagedIssueTypes,
        tooltip: t('errors.settingsTabDisabled'),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userRoles?.hasManagedIssueTypes],
  );

  useEffect(() => {
    setHeaderProps({
      viewTitle: {
        breadcrumbSections: [{ url: '/', title: t('common:appName') }],
        title: t('settings:routeName'),
      },
    });
  }, []);

  return (
    <Stack height='100%' component='div'>
      <HeaderTabs tabs={tabs} />
      <Outlet />
    </Stack>
  );
}
